<script setup>
import {reactive} from "vue";
import {message} from "ant-design-vue";
import userPlayerService from "@/stores/user-player";

const title = "Thông tin vận động viên";
const text = "Trang chủ";
const text1 = " thông tin vận động viên ";

const form = reactive({
  email: '',
});

const onFinish = async () => {
  if (!form.email) {
    message.error("Vui lòng đồng ý với điều khoản");
    return;
  }

  const data = {
    email: form.email,
  };

  const response = await userPlayerService.changeEmail(data);

  if (response?.data) {
    message.success("Thay đổi email thành công!");
    resetForm();
    resetInfo(form.email);
  } else {
    message.error("Thay đổi email thất bại. Vui lòng thử lại.");
  }
};

const resetForm = () => {
  form.email = '';
};

const resetInfo = (email) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const player = JSON.parse(localStorage.getItem('player'));

  player.email = email;
  user.player.email = email;
  user.info.email = email;

  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('player', JSON.stringify(user.player));
}
</script>
<template>
  <user-header></user-header>
  <breadcrumb :text="text" :text1="text1" :title="title"/>
  <user-tabset></user-tabset>
  <div class="content court-bg">
    <div class="container">
      <settings-sidebar></settings-sidebar>

      <div class="row">
        <div class="col-sm-12">
          <div class="profile-detail-group">
            <a-form
                ref="formRef"
                :model="form"
                layout="vertical"
                @finish="onFinish"
            >
              <div class="card">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="appoint-head">
                      <h4>Đổi Email</h4>
                    </div>
                    <div class="input-space">
                      <a-form-item
                          :rules="[
                              { required: true, message: 'Vui lòng nhập email!' },
                              { type: 'email', message: 'Email không hợp lệ!' }
                            ]"
                          label="Email"
                          name="email"
                      >
                        <a-input class="form-control" v-model:value="form.email" placeholder="Vui lòng nhập email"/>
                      </a-form-item>
                    </div>
                  </div>
                </div>
              </div>
              <div class="save-changes text-end">
                <a-form-item>
                  <button class="btn btn-secondary save-profile" type="submit">Lưu thay đổi</button>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
